import { Row, Col, FormGroup } from 'react-bootstrap';
import React, { Component } from 'react';
import FormularioPadrao from '../FormularioPadrao';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import IntegerInput from '../../components/IntegerInput';
import DecimalInput from '../../components/DecimalInput';
import { buildQueryString, updateState } from '../../utils/Functions';
import SubCadastro from '../../components/SubCadastro';
import Select from '../../components/Select';
import SequenciaJAUController from '../../controllers/Sequencias/SequenciaJAUController';
import { showError } from '../../components/Messages';
import {
   getTiposDeTestesJAU,
   getTiposDeResistenciaJAU,
   getTiposDeUnidadeDeDesvioJAU,
   getTiposDeAmplitudeJAU,
   getTiposDeSinalJAU,
   getTiposDeTipoDeSinalSicronismoJAU,
   getTiposDeUnidadeDeDesvioECGAmplitudeJAU,
   getTiposDeUnidadeDeDesvioECGFrequenciaJAU,
   getTiposDeArritmiasPerformanceJAU,
   getTiposDeSinalSenoideJAU,
   getTiposDeArritimiaJAU,
   getTiposDeSinalArritimiaJAU,
   getTiposDeAmplitudeRespiracaoJAU,
   getTiposDeTaxaDeInspJAU,
   getTiposDeUnidadeDeDesvioRespiracaoJAU,
   getTiposDeUnidadeDeDesvioRespiracaoBRPMJAU,
   getTiposDeTipoDeSinalJAUECG,
} from './../Descricoes';
import { Link } from 'react-router-dom';
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../components/IconButton';
import TipoDeEnsaioView from './TipoDeEnsaioView';
import Button from '../../components/Button';
import CheckListView from '../Empresa/CheckListView';

const TIPO_DE_TESTE = {
   TJ_ENERGIA: 0,
   TJ_DELAY_SYNC: 1,
   TJ_CARGA_CAPACITOR: 2,
   TJ_ECG_FREQ: 3,
   TJ_ECG_AMPL: 4,
   TJ_SINAIS: 5,
   TJ_RESPIRACAO_FREQ: 6,
   TJ_RESPIRACAO_AMPL: 7,
   TJ_APNEIA: 8,
};

export default class SequenciaJAUMPView extends Component {
   constructor(props) {
      super(props);
      this.state = {};
      this.controller = new SequenciaJAUController(this);
   }

   setUltimoItemCriado = (item) => {
      updateState(this, (state) => {
         state.ultimoItemCriado = {};
         state.ultimoItemCriado.numero = item.numero;
         state.ultimoItemCriado.carga = item.carga;
         state.ultimoItemCriado.delayMaximo = item.delayMaximo;
         state.ultimoItemCriado.tempoCargaCapacitor = item.tempoCargaCapacitor;
         state.ultimoItemCriado.tipoDeSinal = item.tipoDeSinal;
         state.ultimoItemCriado.sinal = item.sinal;
         state.ultimoItemCriado.amplitude = item.amplitude;
         state.ultimoItemCriado.energia = item.energia;
         state.ultimoItemCriado.limiteSuperior = item.limiteSuperior;
         state.ultimoItemCriado.limiteInferior = item.limiteInferior;
         state.ultimoItemCriado.unidadeLimites = item.unidadeLimites;
         state.ultimoItemCriado.tipoDeSinalECG = item.tipoDeSinalECG;
         state.ultimoItemCriado.sinalECG = item.sinalECG;
         state.ultimoItemCriado.amplitudeECG = item.amplitudeECG;
         state.ultimoItemCriado.respiracao_Frequencia = item.respiracao_Frequencia;
         state.ultimoItemCriado.respiracao_Taxa = item.respiracao_Taxa;
         state.ultimoItemCriado.respiracao_Amplitude = item.respiracao_Amplitude;
         state.ultimoItemCriado.respiracao_TempoApneia = item.respiracao_TempoApneia;
         state.ultimoItemCriado.tipoDeTeste = item.tipoDeTeste;
      });
   };

   getDescricaoDotipoTesteJAU = (id) => {
      let result = getTiposDeTestesJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDaUnidadeDesvioJAU = (id) => {
      let result = getTiposDeUnidadeDeDesvioJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeSinalJAU = (id) => {
      let result = getTiposDeSinalJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeUnidadeDeDesvioECGFrequenciaJAU = (id) => {
      let result = getTiposDeUnidadeDeDesvioECGFrequenciaJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeUnidadeDeDesvioECGAmplitudeJAU = (id) => {
      let result = getTiposDeUnidadeDeDesvioECGAmplitudeJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeSinalArritimiaJAU = (id) => {
      let result = getTiposDeSinalArritimiaJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeSinalSenoideJAU = (id) => {
      let result = getTiposDeSinalSenoideJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeAmplitudeRespiracaoJAU = (id) => {
      let result = getTiposDeAmplitudeRespiracaoJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeUnidadeDeDesvioRespiracaoJAU = (id) => {
      let result = getTiposDeUnidadeDeDesvioRespiracaoJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeUnidadeDeDesvioRespiracaobrpmJAU = (id) => {
      let result = getTiposDeUnidadeDeDesvioRespiracaoBRPMJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   getDescricaoDeAmplitudeJAU = (id) => {
      let result = getTiposDeAmplitudeJAU(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   renderizarFormulario = () => {
      let lang = this.props.lang;
      return (
         <React.Fragment>
            <Row>
               <Col sm={2} md={2} lg={2}>
                  <FormGroup>
                     <Label>{lang.codigo}</Label>
                     <TextInput readOnly defaultValue={this.state.itemSelecionado.id} />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{lang.sequencia.nome}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.nome}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.nome = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>
               <Col sm={3} md={3} lg={3}>
                  <FormGroup>
                     <Label>{lang.sequencia.situacao}</Label>
                     <Select
                        name='situacao'
                        defaultValue={this.state.itemSelecionado.situacao && this.state.itemSelecionado.situacao.id}
                        options={[
                           { id: 1, descricao: lang.sequencia.ativa },
                           { id: 2, descricao: lang.sequencia.inativa },
                        ]}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.descricao}
                        onSelect={(i) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.situacao = i;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <br />

            <SubCadastro
               titulo={lang.sequencia.tiposDeEnsaio}
               modal={true}
               exibirTitulos={false}
               itens={this.state.itemSelecionado.tiposDeEnsaio}
               lang={lang}
               novo={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.tipoDeEnsaioSelecionado = {
                           tipoDeEnsaio: null,
                        };
                     }).then(() => resolve());
                  });
               }}
               inserir={() => {
                  return new Promise((resolve, reject) => {
                     if (!this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio) {
                        showError(lang.sequencia.mensagens.informeOTipoDeEnsaio);
                        reject();
                        return false;
                     }

                     updateState(this, (state) => {
                        if (!state.itemSelecionado.tiposDeEnsaio) {
                           state.itemSelecionado.tiposDeEnsaio = [];
                        }
                        state.itemSelecionado.tiposDeEnsaio.push({
                           tipoDeEnsaio: this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio,
                        });
                     }).then(() => resolve());
                  });
               }}
               cancelar={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.tipoDeEnsaioSelecionado = null;
                     }).then(() => resolve());
                  });
               }}
               excluir={(index) => {
                  updateState(this, (state) => {
                     state.itemSelecionado.tiposDeEnsaio.splice(index, 1);
                  });
               }}
               colunas={() => {
                  return [{ titulo: 'Cargo', width: '100%', className: null }];
               }}
               linha={(item) => {
                  return [item.tipoDeEnsaio.nome];
               }}
               formulario={() => {
                  return (
                     <Row>
                        <Col>
                           <Label>{lang.sequencia.tipoDeEnsaio}</Label>
                           <Select
                              name={'tipoDeEnsaio'}
                              modal={true}
                              defaultValue={this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio}
                              getKeyValue={(i) => i.id}
                              getDescription={(i) => (i && i.nome ? i.nome.toUpperCase() : null)}
                              onSelect={(i) => {
                                 updateState(this, (state) => {
                                    state.tipoDeEnsaioSelecionado.tipoDeEnsaio = i;
                                 });
                              }}
                              formularioPadrao={(select) => {
                                 return (
                                    <TipoDeEnsaioView api={this.props.api} select={select} lang={this.props.lang} />
                                 );
                              }}
                              asws={true}
                              noDropDown={true}
                              readOnlyColor='#ffff'
                              getFilterUrl={(text) =>
                                 '/tipodeensaio' + buildQueryString(2, null, 'id', { Searchable: text })
                              }
                           />
                        </Col>
                     </Row>
                  );
               }}
            />

            <br />
            {!this.state.itemSelecionado.sequenciaNeos && (
               <SubCadastro
                  titulo={lang.sequencia.checkList}
                  modal={true}
                  exibirTitulos={false}
                  itens={this.state.itemSelecionado.checkList}
                  lang={lang}
                  novo={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.checkListSelecionado = {
                              checkList: null,
                           };
                        }).then(() => resolve());
                     });
                  }}
                  inserir={() => {
                     return new Promise((resolve, reject) => {
                        if (!this.state.checkListSelecionado.checkList) {
                           showError(lang.sequencia.mensagens.informeOCheckList);
                           reject();
                           return false;
                        }

                        updateState(this, (state) => {
                           if (!state.itemSelecionado.checkList) {
                              state.itemSelecionado.checkList = [];
                           }
                           state.itemSelecionado.checkList.push({
                              checkList: this.state.checkListSelecionado.checkList,
                           });
                        }).then(() => resolve());
                     });
                  }}
                  cancelar={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.checkListSelecionado = null;
                        }).then(() => resolve());
                     });
                  }}
                  excluir={(index) => {
                     updateState(this, (state) => {
                        state.itemSelecionado.checkList.splice(index, 1);
                     });
                  }}
                  colunas={() => {
                     return [{ titulo: lang.sequencia.checkList, width: '100%', className: null }];
                  }}
                  linha={(item) => {
                     return [item.checkList.descricao];
                  }}
                  formulario={() => {
                     return (
                        <Row>
                           <Col>
                              <Label>{lang.sequencia.checkList}</Label>
                              <Select
                                 name={'checkList'}
                                 modal={true}
                                 defaultValue={this.state.checkListSelecionado.checkList}
                                 getKeyValue={(i) => i.id}
                                 getDescription={(i) => i.descricao}
                                 onSelect={(i) => {
                                    updateState(this, (state) => {
                                       state.checkListSelecionado.checkList = i;
                                    });
                                 }}
                                 formularioPadrao={(select) => {
                                    return (
                                       <CheckListView api={this.props.api} select={select} lang={this.props.lang} />
                                    );
                                 }}
                                 noDropDown={true}
                                 readOnlyColor='#ffff'
                                 getFilterUrl={(text) =>
                                    '/checklist' + buildQueryString(2, null, 'descricao', { Searchable: text })
                                 }
                              />
                           </Col>
                        </Row>
                     );
                  }}
               />
            )}

            <br />
            <SubCadastro
               titulo='Testes'
               exibirTitulos={true}
               itens={this.state.itemSelecionado.itens}
               gradeSempreVisivel={true}
               tituloDoBotaoCancelar={lang.sequencia.finalizarCadastroDeTeste}
               lang={lang}
               novo={
                  !this.state.itemSelecionado.sequenciaNeos ||
                  (this.state.itemSelecionado.sequenciaNeos && this.props.sessionManager.isUsuarioNeos())
                     ? () => {
                          return new Promise((resolve) => {
                             let maiorNumero = 0;
                             if (this.state.itemSelecionado.itens) {
                                this.state.itemSelecionado.itens.map((i, index) => {
                                   if (i.numero > maiorNumero) {
                                      maiorNumero = i.numero;
                                   }
                                   return true;
                                });
                             }
                             maiorNumero++;
                             updateState(this, (state) => {
                                state.configuracaoSelecionada = null;
                                let configuracaoSelecionada = { tipoDeTeste: 0 };
                                this.setValoresDefault(configuracaoSelecionada);
                                configuracaoSelecionada.numero = maiorNumero;
                                state.configuracaoSelecionada = configuracaoSelecionada;
                             }).then(() => resolve());
                          });
                       }
                     : null
               }
               inserir={() => {
                  return new Promise((resolve, reject) => {
                     if (!this.state.configuracaoSelecionada.numero) {
                        showError(lang.sequencia.informeONumero);
                        reject();
                        return false;
                     }

                     // if (!this.state.configuracaoSelecionada.repeticoes) {
                     //    showError(lang.sequencia.informeONumeroDeRepeticoes);
                     //    reject();
                     //    return false;
                     // }

                     if (
                        this.state.configuracaoSelecionada.tipoDeTeste === null ||
                        this.state.configuracaoSelecionada.tipoDeTeste === undefined
                     ) {
                        showError(lang.cadastroDeSequenciaJAU.mensagens.informeOTipoDeTeste);
                        reject();
                        return false;
                     }
                     updateState(this, (state) => {
                        if (!state.itemSelecionado.itens) {
                           state.itemSelecionado.itens = [];
                        }

                        let item = {
                           numero: this.state.configuracaoSelecionada.numero,
                           // repeticoes: this.state.configuracaoSelecionada.repeticoes,
                           repeticoes: 1,
                           carga: this.state.configuracaoSelecionada.carga,
                           delayMaximo: this.state.configuracaoSelecionada.delayMaximo,
                           tempoCargaCapacitor: this.state.configuracaoSelecionada.tempoCargaCapacitor,
                           tipoDeSinal: this.state.configuracaoSelecionada.tipoDeSinal,
                           sinal: this.state.configuracaoSelecionada.sinal,
                           amplitude: this.state.configuracaoSelecionada.amplitude,
                           energia: this.state.configuracaoSelecionada.energia,
                           limiteSuperior: this.state.configuracaoSelecionada.limiteSuperior,
                           limiteInferior: this.state.configuracaoSelecionada.limiteInferior,
                           unidadeLimites: this.state.configuracaoSelecionada.unidadeLimites,
                           tipoDeSinalECG: this.state.configuracaoSelecionada.tipoDeSinalECG,
                           sinalECG: this.state.configuracaoSelecionada.sinalECG,
                           amplitudeECG: this.state.configuracaoSelecionada.amplitudeECG,
                           respiracao_Frequencia: this.state.configuracaoSelecionada.respiracao_Frequencia,
                           respiracao_Taxa: this.state.configuracaoSelecionada.respiracao_Taxa,
                           respiracao_Amplitude: this.state.configuracaoSelecionada.respiracao_Amplitude,
                           respiracao_TempoApneia: this.state.configuracaoSelecionada.respiracao_TempoApneia,
                           tipoDeTeste: this.state.configuracaoSelecionada.tipoDeTeste,
                        };

                        state.itemSelecionado.itens.push(item);
                        this.setUltimoItemCriado(item);
                     }).then(() => resolve());
                  });
               }}
               aposSalvar={this.aposSalvar}
               selecionarParaAlteracao={(index) => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = JSON.parse(JSON.stringify(state.itemSelecionado.itens[index]));
                     }).then(() => resolve());
                  });
               }}
               alterar={(index) => {
                  return new Promise((resolve, reject) => {
                     if (!this.state.configuracaoSelecionada.numero) {
                        showError(lang.sequencia.informeONumero);
                        reject();
                        return false;
                     }

                     updateState(this, (state) => {
                        state.itemSelecionado.itens[index].numero = this.state.configuracaoSelecionada.numero;
                        state.itemSelecionado.itens[index].repeticoes = this.state.configuracaoSelecionada.repeticoes;
                        state.itemSelecionado.itens[index].carga = this.state.configuracaoSelecionada.carga;
                        state.itemSelecionado.itens[index].delayMaximo = this.state.configuracaoSelecionada.delayMaximo;
                        state.itemSelecionado.itens[index].tempoCargaCapacitor =
                           this.state.configuracaoSelecionada.tempoCargaCapacitor;
                        state.itemSelecionado.itens[index].tipoDeSinal = this.state.configuracaoSelecionada.tipoDeSinal;
                        state.itemSelecionado.itens[index].sinal = this.state.configuracaoSelecionada.sinal;
                        state.itemSelecionado.itens[index].amplitude = this.state.configuracaoSelecionada.amplitude;
                        state.itemSelecionado.itens[index].energia = this.state.configuracaoSelecionada.energia;
                        state.itemSelecionado.itens[index].limiteSuperior =
                           this.state.configuracaoSelecionada.limiteSuperior;
                        state.itemSelecionado.itens[index].limiteInferior =
                           this.state.configuracaoSelecionada.limiteInferior;
                        state.itemSelecionado.itens[index].unidadeLimites =
                           this.state.configuracaoSelecionada.unidadeLimites;
                        state.itemSelecionado.itens[index].tipoDeSinalECG =
                           this.state.configuracaoSelecionada.tipoDeSinalECG;
                        state.itemSelecionado.itens[index].sinalECG = this.state.configuracaoSelecionada.sinalECG;
                        state.itemSelecionado.itens[index].amplitudeECG =
                           this.state.configuracaoSelecionada.amplitudeECG;
                        state.itemSelecionado.itens[index].respiracao_Frequencia =
                           this.state.configuracaoSelecionada.respiracao_Frequencia;
                        state.itemSelecionado.itens[index].respiracao_Taxa =
                           this.state.configuracaoSelecionada.respiracao_Taxa;
                        state.itemSelecionado.itens[index].respiracao_Amplitude =
                           this.state.configuracaoSelecionada.respiracao_Amplitude;
                        state.itemSelecionado.itens[index].respiracao_TempoApneia =
                           this.state.configuracaoSelecionada.respiracao_TempoApneia;
                        state.itemSelecionado.itens[index].tipoDeTeste = this.state.configuracaoSelecionada.tipoDeTeste;
                        this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                     }).then(() => resolve());
                  });
               }}
               cancelar={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = null;
                     }).then(() => resolve());
                  });
               }}
               excluir={
                  !this.state.itemSelecionado.sequenciaNeos ||
                  (this.state.itemSelecionado.sequenciaNeos && this.props.sessionManager.isUsuarioNeos())
                     ? (index) => {
                          updateState(this, (state) => {
                             state.itemSelecionado.itens.splice(index, 1);
                             state.itemSelecionado.itens.map((i, index) => (i.numero = index + 1));
                          });
                       }
                     : null
               }
               colunas={() => {
                  return [
                     { titulo: 'Nº', width: '3%', className: null },
                     { titulo: 'Tipo de Teste', width: '20%', className: null },
                     { titulo: 'Valor de referência', width: '20%', className: null },
                     { titulo: 'Desvio máximo superior', width: '17%', className: null },
                     { titulo: 'Desvio máximo inferior', width: '16%', className: null },
                     { titulo: 'Unid desvio', width: '25%', className: null },
                  ];
               }}
               linha={(item) => {
                  if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_ENERGIA) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        item.energia + ' J',
                        item.limiteSuperior,
                        item.limiteInferior,
                        this.getDescricaoDaUnidadeDesvioJAU(item.unidadeLimites),
                     ];
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_DELAY_SYNC) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        item.delayMaximo + ' ms',
                        0,
                        0,
                        '-',
                     ];
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_CARGA_CAPACITOR) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        item.tempoCargaCapacitor + ' s',
                        0,
                        0,
                        '-',
                     ];
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_FREQ) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        this.getDescricaoDeSinalJAU(item.sinalECG),
                        item.limiteSuperior,
                        item.limiteInferior,
                        this.getDescricaoDeUnidadeDeDesvioECGFrequenciaJAU(item.unidadeLimites),
                     ];
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_AMPL) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        this.getDescricaoDeAmplitudeJAU(item.amplitudeECG),
                        item.limiteSuperior,
                        item.limiteInferior,
                        this.getDescricaoDeUnidadeDeDesvioECGAmplitudeJAU(item.unidadeLimites),
                     ];
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_SINAIS) {
                     if (item.tipoDeSinalECG === 1) {
                        return [
                           item.numero,
                           this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                           this.getDescricaoDeSinalArritimiaJAU(item.sinalECG),
                           '-',
                           '-',
                           '-',
                        ];
                     } else 
                     if (item.tipoDeSinalECG === 2) {
                        return [
                           item.numero,
                           this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                           this.getDescricaoDeSinalSenoideJAU(item.sinalECG),
                           '-',
                           '-',
                           '-',
                        ];
                     }
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_FREQ) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        this.getDescricaoDeAmplitudeRespiracaoJAU(item.amplitude),
                        item.limiteSuperior,
                        item.limiteInferior,
                        this.getDescricaoDeUnidadeDeDesvioRespiracaobrpmJAU(item.unidadeLimites),
                     ];
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_AMPL) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        item.respiracao_Amplitude + ' BrPm',
                        item.limiteSuperior,
                        item.limiteInferior,
                        this.getDescricaoDeUnidadeDeDesvioRespiracaoJAU(item.unidadeLimites),
                     ];
                  } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_APNEIA) {
                     return [
                        item.numero,
                        this.getDescricaoDotipoTesteJAU(item.tipoDeTeste),
                        item.respiracao_TempoApneia + ' s',
                        0,
                        0,
                        '-',
                     ];
                  }
               }}
               acoes={(subCadastro, index) => {
                  return (
                     <div style={{ display: 'table-cell', margin: 'auto', marginRight: 4, width: 25 }}>
                        <IconButton
                           title={lang.formularioPadrao.alterar}
                           style={{ fontSize: 23, marginBottom: -10 }}
                           cursor='pointer'
                           icon={faSortUp}
                           onClick={() => {
                              if (this.state.itemSelecionado.itens[index].numero > 1) {
                                 updateState(this, (state) => {
                                    state.itemSelecionado.itens[index - 1].numero =
                                       state.itemSelecionado.itens[index].numero;
                                    state.itemSelecionado.itens[index].numero =
                                       state.itemSelecionado.itens[index].numero - 1;
                                 }).then(() => {
                                    this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                                    this.aposSalvar(subCadastro, false, true);
                                 });
                              }
                           }}
                        />
                        <IconButton
                           title={lang.formularioPadrao.alterar}
                           style={{ fontSize: 23, marginTop: -10 }}
                           cursor='pointer'
                           icon={faSortDown}
                           onClick={() => {
                              if (
                                 this.state.itemSelecionado.itens[index].numero <
                                 this.state.itemSelecionado.itens.length
                              ) {
                                 updateState(this, (state) => {
                                    state.itemSelecionado.itens[index + 1].numero =
                                       state.itemSelecionado.itens[index].numero;
                                    state.itemSelecionado.itens[index].numero =
                                       state.itemSelecionado.itens[index].numero + 1;
                                 }).then(() => {
                                    this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                                    this.aposSalvar(subCadastro, false, true);
                                 });
                              }
                           }}
                        />
                     </div>
                  );
               }}
               formulario={() => {
                  return this.state.configuracaoSelecionada ? (
                     <div>
                        <Row>
                        <Col sm={2} md={2} lg={2}>
                              <FormGroup>
                                 <Label>{lang.sequencia.numero}</Label>
                                 <IntegerInput
                                    defaultValue={this.state.configuracaoSelecionada.numero}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.numero = e.floatValue;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           {/* <Col xs={2} md={2} xl={2}>
                              <FormGroup>
                                 <Label>{lang.sequencia.repeticoes}</Label>
                                 <IntegerInput
                                    // defaultValue={this.state.configuracaoSelecionada.repeticoes}
                                    defaultValue={1}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.repeticoes = e.floatValue;
                                       });
                                    }}
                                    readOnly={true}
                                 />
                              </FormGroup>
                           </Col> */}
                           <Col>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaJAU.tipoDeTeste}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.tipoDeTeste}
                                    options={getTiposDeTestesJAU(lang)}
                                    getKeyValue={(i) => i.id}
                                    allowEmpty={false}
                                    getDescription={(i) => i.descricao}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.tipoDeTeste = i.id;
                                          } else {
                                             state.configuracaoSelecionada.tipoDeTeste = 0;
                                          }
                                          let configuracaoSelecionada = state.configuracaoSelecionada;
                                          this.setValoresDefault(configuracaoSelecionada);
                                          state.configuracaoSelecionada = configuracaoSelecionada;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                        </Row>

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_ENERGIA && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.energia}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.energia}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.energia = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.resistencia}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.carga}
                                       options={getTiposDeResistenciaJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.carga = i.id;
                                             } else {
                                                state.configuracaoSelecionada.carga = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.unidadeDeDesvio}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDeDesvioJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_ENERGIA && (
                           <Row>
                              <Col xs={6} md={6} xl={6}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoSuperior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteSuperior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteSuperior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={6} md={6} xl={6}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoInferior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteInferior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteInferior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_DELAY_SYNC && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.energia}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.energia}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.energia = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.resistencia}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.carga}
                                       options={getTiposDeResistenciaJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.carga = i.id;
                                             } else {
                                                state.configuracaoSelecionada.carga = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.limiteSync}</Label>
                                    <DecimalInput
                                       lang={lang}
                                       defaultValue={this.state.configuracaoSelecionada.delayMaximo}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.delayMaximo = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}
                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_DELAY_SYNC && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.tipoDeSinal}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.tipoDeSinal}
                                       options={getTiposDeTipoDeSinalSicronismoJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.tipoDeSinal = i.id;
                                             } else {
                                                state.configuracaoSelecionada.tipoDeSinal = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.sinal}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.sinal}
                                       options={getTiposDeSinalJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.sinal = i.id;
                                             } else {
                                                state.configuracaoSelecionada.sinal = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.amplitude}
                                       options={getTiposDeAmplitudeJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.amplitude = i.id;
                                             } else {
                                                state.configuracaoSelecionada.amplitude = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_CARGA_CAPACITOR && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.energia}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.energia}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.energia = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.resistencia}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.carga}
                                       options={getTiposDeResistenciaJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.carga = i.id;
                                             } else {
                                                state.configuracaoSelecionada.carga = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.limiteTempoCarga}</Label>
                                    <DecimalInput
                                       lang={lang}
                                       defaultValue={this.state.configuracaoSelecionada.tempoCargaCapacitor}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.tempoCargaCapacitor = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}
                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_FREQ && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.tipoDeSinal}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.tipoDeSinalECG}
                                       options={getTiposDeTipoDeSinalJAUECG(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.tipoDeSinalECG = i.id;
                                             } else {
                                                state.configuracaoSelecionada.tipoDeSinalECG = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.sinal}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.sinalECG}
                                       options={getTiposDeSinalJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.sinalECG = i.id;
                                             } else {
                                                state.configuracaoSelecionada.sinalECG = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.amplitudeECG}
                                       options={getTiposDeAmplitudeJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.amplitudeECG = i.id;
                                             } else {
                                                state.configuracaoSelecionada.amplitudeECG = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_FREQ && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoSuperior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteSuperior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteSuperior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoInferior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteInferior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteInferior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.unidadeDeDesvio}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDeDesvioECGFrequenciaJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_AMPL && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.tipoDeSinal}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.tipoDeSinalECG}
                                       options={getTiposDeTipoDeSinalJAUECG(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       asws={true}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.tipoDeSinalECG = i.id;
                                             } else {
                                                state.configuracaoSelecionada.tipoDeSinalECG = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.sinal}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.sinalECG}
                                       options={getTiposDeSinalJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.sinalECG = i.id;
                                             } else {
                                                state.configuracaoSelecionada.sinalECG = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.amplitudeECG}
                                       options={getTiposDeAmplitudeJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.amplitudeECG = i.id;
                                             } else {
                                                state.configuracaoSelecionada.amplitudeECG = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_AMPL && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoSuperior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteSuperior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteSuperior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoInferior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteInferior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteInferior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.unidadeDeDesvio}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDeDesvioECGAmplitudeJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_SINAIS && (
                           <Row>
                              <Col>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.tipoDeSinal}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.tipoDeSinalECG}
                                       options={getTiposDeArritmiasPerformanceJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.tipoDeSinalECG = i.id;
                                                if (state.configuracaoSelecionada.tipoDeSinalECG === 1) {
                                                   state.configuracaoSelecionada.sinalECG = 31;
                                                }
                                                if (state.configuracaoSelecionada.tipoDeSinalECG === 2) {
                                                   state.configuracaoSelecionada.sinalECG = 100;
                                                }
                                             } else {
                                                state.configuracaoSelecionada.tipoDeSinalECG = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_SINAIS && (
                           <Row>
                              {this.state.configuracaoSelecionada.tipoDeSinalECG === 1 && (
                                 <Col xs={6} md={6} xl={6}>
                                    <FormGroup>
                                       <Label>{lang.cadastroDeSequenciaJAU.sinal}</Label>
                                       <Select
                                          defaultValue={this.state.configuracaoSelecionada.sinalECG}
                                          options={getTiposDeSinalArritimiaJAU(lang)}
                                          getKeyValue={(i) => i.id}
                                          allowEmpty={false}
                                          getDescription={(i) => i.descricao}
                                          onSelect={(i) => {
                                             updateState(this, (state) => {
                                                if (i != null) {
                                                   state.configuracaoSelecionada.sinalECG = i.id;
                                                } else {
                                                   state.configuracaoSelecionada.sinalECG = 0;
                                                }
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              )}

                              {this.state.configuracaoSelecionada.tipoDeSinalECG === 2 && (
                                 <Col xs={6} md={6} xl={6}>
                                    <FormGroup>
                                       <Label>{lang.cadastroDeSequenciaJAU.sinal}</Label>
                                       <Select
                                          defaultValue={this.state.configuracaoSelecionada.sinalECG}
                                          options={getTiposDeSinalSenoideJAU(lang)}
                                          getKeyValue={(i) => i.id}
                                          allowEmpty={false}
                                          getDescription={(i) => i.descricao}
                                          onSelect={(i) => {
                                             updateState(this, (state) => {
                                                if (i != null) {
                                                   state.configuracaoSelecionada.sinalECG = i.id;
                                                } else {
                                                   state.configuracaoSelecionada.sinalECG = 0;
                                                }
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              )}
                              {this.state.configuracaoSelecionada.tipoDeSinalECG === 1 && (
                                 <Col xs={6} md={6} xl={6}>
                                    <FormGroup>
                                       <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                       <Select
                                          defaultValue={this.state.configuracaoSelecionada.amplitudeECG}
                                          options={getTiposDeArritimiaJAU(lang)}
                                          getKeyValue={(i) => i.id}
                                          allowEmpty={false}
                                          getDescription={(i) => i.descricao}
                                          onSelect={(i) => {
                                             updateState(this, (state) => {
                                                if (i != null) {
                                                   state.configuracaoSelecionada.amplitudeECG = i.id;
                                                } else {
                                                   state.configuracaoSelecionada.amplitudeECG = 0;
                                                }
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              )}

                              {this.state.configuracaoSelecionada.tipoDeSinalECG &&
                                 this.state.configuracaoSelecionada.tipoDeSinalECG === 2 && (
                                    <Col xs={6} md={6} xl={6}>
                                       <FormGroup>
                                          <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                          <Select
                                             defaultValue={this.state.configuracaoSelecionada.amplitudeECG}
                                             options={getTiposDeAmplitudeJAU(lang)}
                                             getKeyValue={(i) => i.id}
                                             allowEmpty={false}
                                             getDescription={(i) => i.descricao}
                                             onSelect={(i) => {
                                                updateState(this, (state) => {
                                                   if (i != null) {
                                                      state.configuracaoSelecionada.amplitudeECG = i.id;
                                                   } else {
                                                      state.configuracaoSelecionada.amplitudeECG = 0;
                                                   }
                                                });
                                             }}
                                          />
                                       </FormGroup>
                                    </Col>
                                 )}
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_FREQ && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.frequenciaBRPM}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.respiracao_Frequencia}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.respiracao_Frequencia = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.taxaInsp}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.respiracao_Taxa}
                                       options={getTiposDeTaxaDeInspJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.respiracao_Taxa = i.id;
                                             } else {
                                                state.configuracaoSelecionada.respiracao_Taxa = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>

                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.amplitude}
                                       options={getTiposDeAmplitudeRespiracaoJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.amplitude = i.id;
                                             } else {
                                                state.configuracaoSelecionada.amplitude = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_FREQ && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoSuperior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteSuperior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteSuperior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoInferior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteInferior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteInferior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.unidadeDeDesvio}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDeDesvioRespiracaoBRPMJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_AMPL && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.frequenciaBRPM}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.respiracao_Amplitude}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.respiracao_Amplitude = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.taxaInsp}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.respiracao_Taxa}
                                       options={getTiposDeTaxaDeInspJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.respiracao_Taxa = i.id;
                                             } else {
                                                state.configuracaoSelecionada.respiracao_Taxa = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>

                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.amplitude}
                                       options={getTiposDeAmplitudeRespiracaoJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.amplitude = i.id;
                                             } else {
                                                state.configuracaoSelecionada.amplitude = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_AMPL && (
                           <Row>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoSuperior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteSuperior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteSuperior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.desvioMaximoInferior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteInferior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteInferior = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={4} md={4} xl={4}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.unidadeDeDesvio}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDeDesvioRespiracaoJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_APNEIA && (
                           <Row>
                              <Col xs={6} md={6} xl={6}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.tempodeApneia}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.respiracao_TempoApneia}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.respiracao_TempoApneia = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>

                              <Col xs={6} md={6} xl={6}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.frequenciaBRPM}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.respiracao_Frequencia}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.respiracao_Frequencia = e.value;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste === TIPO_DE_TESTE.TJ_APNEIA && (
                           <Row>
                              <Col xs={6} md={6} xl={6}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.taxaInsp}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.respiracao_Taxa}
                                       options={getTiposDeTaxaDeInspJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.respiracao_Taxa = i.id;
                                             } else {
                                                state.configuracaoSelecionada.respiracao_Taxa = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>

                              <Col xs={6} md={6} xl={6}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaJAU.amplitude}</Label>
                                    <Select
                                       defaultValue={this.state.configuracaoSelecionada.amplitude}
                                       options={getTiposDeAmplitudeRespiracaoJAU(lang)}
                                       getKeyValue={(i) => i.id}
                                       allowEmpty={false}
                                       getDescription={(i) => i.descricao}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.amplitude = i.id;
                                             } else {
                                                state.configuracaoSelecionada.amplitude = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}
                     </div>
                  ) : (
                     <div />
                  );
               }}
            />
            <br />
         </React.Fragment>
      );
   };

   renderizarAcoesDoFormulario = () => {
      return (
         <div>
            <Button
               text={this.props.lang.sequencia.duplicarSequencia}
               style={{ width: 200 }}
               onClick={() => {
                  let item = JSON.parse(JSON.stringify(this.state.itemSelecionado));
                  item.id = null;
                  if (item.itens != null) {
                     for (let i = 0; i < item.itens.length; i++) {
                        item.itens[i].id = null;
                     }
                  }
                  if (item.tiposDeEnsaio != null) {
                     for (let i = 0; i < item.tiposDeEnsaio.length; i++) {
                        item.tiposDeEnsaio[i].id = null;
                     }
                  }

                  updateState(this, (state) => {
                     state.incluindo = false;
                     state.alterando = false;
                     state.valorPadrao = item;
                  }).then(() => {
                     this.form.inserirClick();
                  });
               }}
            />
            <br />
         </div>
      );
   };

   aposSalvar = (subCadastro, inserindo, alterando) => {
      let ordem = this.state.ultimoItemCriado.numero;
      updateState(this, (state) => {
         state.itemSelecionado.itens.sort((i, j) => {
            let result = i.numero < j.numero ? -1 : i.numero > j.numero ? 1 : 0;
            if (j.numero === ordem && i.numero === ordem) {
               result = -1;
            }
            return result;
         });
         state.itemSelecionado.itens.map((i, index) => (i.numero = index + 1));
      });
      if (inserindo) {
         subCadastro.novo();
      }
   };

   setValoresDefault = (item) => {
      let padrao = null;

      if (this.state.ultimoItemCriado && !this.state.configuracaoSelecionada) {
         padrao = this.state.ultimoItemCriado;
      } else if (item !== null) {
         if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_ENERGIA) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               energia: 10,
               carga: 0,
               limiteSuperior: 10,
               limiteInferior: 10,
               unidadeLimites: 1,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_DELAY_SYNC) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               energia: 10,
               carga: 0,
               delayMaximo: 5,
               tipoDeSinal: 0,
               sinalECG: 200,
               amplitudeECG: 1,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_CARGA_CAPACITOR) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               energia: 10,
               carga: 0,
               tempoCargaCapacitor: 15,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_FREQ) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               tipoDeSinalECG: 0,
               sinalECG: 204,
               limiteSuperior: 5,
               limiteInferior: 5,
               unidadeLimites: 0,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_ECG_AMPL) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               tipoDeSinalECG: 0,
               sinalECG: 204,
               limiteSuperior: 10,
               limiteInferior: 10,
               unidadeLimites: 0,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_SINAIS) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               tipoDeSinalECG: 1,
               sinalECG: 9,
               amplitudeECG: 1,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_FREQ) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               respiracao_Frequencia: 20,
               respiracao_Amplitude: 1,
               Respiracao_Taxa: 1,
               limiteSuperior: 10,
               limiteInferior: 10,
               unidadeLimites: 0,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_RESPIRACAO_AMPL) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               respiracao_Frequencia: 20,
               respiracao_Amplitude: 1,
               Respiracao_Taxa: 1,
               limiteSuperior: 10,
               limiteInferior: 10,
               unidadeLimites: 0,
            };
         } else if (item.tipoDeTeste === TIPO_DE_TESTE.TJ_APNEIA) {
            padrao = {
               tipoDeTeste: item.tipoDeTeste,
               respiracao_TempoApneia: 12,
               respiracao_Frequencia: 20,
               Respiracao_Taxa: 2,
               respiracao_Amplitude: 1,
            };
         }
      } else {
         padrao = {
            tipoDeTeste: 0,
         };
      }

      if (padrao) {
         item.repeticoes = 1;
         item.carga = padrao.carga;
         item.delayMaximo = padrao.delayMaximo;
         item.tempoCargaCapacitor = padrao.tempoCargaCapacitor;
         item.sinal = padrao.sinal;
         item.amplitude = padrao.amplitude;
         item.energia = padrao.energia;
         item.tipoDeTeste = padrao.tipoDeTeste;
         item.limiteSuperior = padrao.limiteSuperior;
         item.limiteInferior = padrao.limiteInferior;
         item.unidadeLimites = padrao.unidadeLimites;
         item.tipoDeSinalECG = padrao.tipoDeSinalECG;
         item.sinalECG = padrao.sinalECG;
         item.amplitudeECG = padrao.amplitudeECG;
         item.tipoDeSinal = padrao.tipoDeSinal;
         item.respiracao_Frequencia = padrao.respiracao_Frequencia;
         item.respiracao_Taxa = padrao.respiracao_Taxa;
         item.respiracao_Amplitude = padrao.respiracao_Amplitude;
         item.respiracao_TempoApneia = padrao.respiracao_TempoApneia;
      }
   };

   render() {
      return (
         <FormularioPadrao
            titulo={
               <div>
                  <Link
                     to={'/sequencia'}
                     replace={true}
                     style={{
                        textDecoration: 'none',
                        padding: '5px 5px 5px 0px',

                        cursor: 'pointer',
                     }}
                  >
                     <span style={{ opacity: 0.7 }}>{this.props.lang.sequencias}</span>                     
                  </Link>
                  <span>{' - '}</span>
                  <span>{this.props.lang.cadastroDeSequenciaJAU.titulo}</span>
               </div>
            }
            url={'/sequenciajau'}
            fastUrl={'/sequenciajau/fast'}
            api={this.props.api}
            lang={this.props.lang}
            ordenacaoPadrao={'nome'}
            permissoes={[1231, 1232, 1233, 1234]}
            getFiltro={this.controller.getFiltro}
            getTitulosDaTabela={this.controller.getTitulosDaTabela}
            getDadosDaTabela={this.controller.getDadosDaTabela}
            renderizarFormulario={this.renderizarFormulario}
            renderizarAcoesDoFormulario={this.renderizarAcoesDoFormulario}
            getObjetoDeDados={this.controller.getObjetoDeDados}
            antesDeInserir={this.controller.antesDeInserir}
            antesDeEditar={this.controller.antesDeEditar}
            antesDeSalvar={this.controller.antesDeSalvar}
            antesDeExcluir={this.controller.antesDeExcluir}
            getFormState={() => {
               return this.state;
            }}
            ref={(c) => (this.form = c)}
            definirValoresPadrao={(item) => {
               return this.state.valorPadrao ? this.state.valorPadrao : item;
            }}
            setFormState={(state, callback) => {
               return new Promise((resolve) => {
                  this.setState(state, () => {
                     resolve();
                     if (callback) {
                        callback();
                     }
                  });
               });
            }}
            select={this.props.select}
            itemVazio={{
               acessos: [],
            }}
         />
      );
   }
}
